/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Valorisation } from './Valorisation'

export class FlatRateTarification {
  constructor(json: JSON | any) {
    Object.assign(this as FlatRateTarification, json)
  }

  code?: string
  flatRateType?: FlatRateTarification.FlatRateTypeEnum
  label?: { [key: string]: string }
  valorisations?: Array<Valorisation>
  /**
   * The base64 encoded data of this object, formatted as JSON and encrypted in AES using the random master key from encryptionKeys.
   */
  encryptedSelf?: string
}
export namespace FlatRateTarification {
  export type FlatRateTypeEnum = 'physician' | 'physiotherapist' | 'nurse' | 'ptd' | 'ivgFlatRate1' | 'ivgFlatRate2' | 'ivgPersonalIntervention'
  export const FlatRateTypeEnum = {
    Physician: 'physician' as FlatRateTypeEnum,
    Physiotherapist: 'physiotherapist' as FlatRateTypeEnum,
    Nurse: 'nurse' as FlatRateTypeEnum,
    Ptd: 'ptd' as FlatRateTypeEnum,
    IvgFlatRate1: 'ivgFlatRate1' as FlatRateTypeEnum,
    IvgFlatRate2: 'ivgFlatRate2' as FlatRateTypeEnum,
    IvgPersonalIntervention: 'ivgPersonalIntervention' as FlatRateTypeEnum,
  }
}
